import { useTranslation } from 'react-i18next';

import { ErrorState, LoadingState } from '@/shared/ui';

import { useReadiness } from './api';
import styles from './SystemStatus.module.css';

/** Reference implementation of the query -> loading / error / data pattern. */
export function SystemStatus() {
  const { t } = useTranslation();
  const readiness = useReadiness();

  if (readiness.isPending) return <LoadingState />;
  if (readiness.isError) {
    return <ErrorState error={readiness.error} onRetry={() => void readiness.refetch()} />;
  }

  const ok = readiness.data.status === 'ok';
  return (
    <section className={styles.card} aria-labelledby="system-status-title">
      <h2 id="system-status-title" className={styles.title}>
        {t('systemStatus.title')}
      </h2>
      <p className={ok ? styles.ok : styles.down}>
        {ok ? t('systemStatus.ok') : t('systemStatus.unavailable')}
      </p>
    </section>
  );
}
